import type { Nullish } from "~/@types/generics"
import type { TProductHeaderBundle } from "~/components/ui/Product/ProductHeader/_data/serializer"
import { remapDefaultValuesFromURLOptions } from "~/components/ui/Product/ProductHeader/ProductDetails/BundleSelector/utils/remap-default-values-from-url-options"

export function getSelectDefaultValues(
  currentOptions: Nullish<string[]>,
  defaultBundleOptions: Nullish<TProductHeaderBundle["defaultBundleOptions"]>
) {
  return (
    (currentOptions && defaultBundleOptions
      ? remapDefaultValuesFromURLOptions(currentOptions, defaultBundleOptions)
      : defaultBundleOptions) ?? {}
  )
}
